import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Twitter, Linkedin, Youtube, MessageSquare, Send, Mail, ArrowRight } from "lucide-react";
const socialLinks = [{
  name: "01: Market Foundations",
  description: "Master the core principles of systematic price action and liquidity dynamics.",
  icon: Twitter,
  url: "/HowItWorksPage"
}, {
  name: "02: Systematic Logic",
  description: "Translating discretionary concepts into repeatable, rule-based trading frameworks.",
  icon: Linkedin,
  url: "/HowItWorksPage"
}, {
  name: "03: Risk Parameters",
  description: "Advanced capital preservation techniques and algorithmic position sizing models.",
  icon: Youtube,
  url: "/HowItWorksPage"
}, {
  name: "04: AI Integration",
  description: "Leveraging machine learning to identify high-probability structural imbalances.",
  icon: MessageSquare,
  url: "/HowItWorksPage"
}, {
  name: "05: Backtesting Alpha",
  description: "Locked: Validating strategies through rigorous historical data simulations.",
  icon: Send,
  url: "#"
}, {
  name: "06: Live Execution",
  description: "Locked: Transitioning from simulation to live market connectivity and automation.",
  icon: Mail,
  url: "#"
}];
const quickLinks = [{
  name: "Home",
  url: "/HomePage"
}, {
  name: "How It Works",
  url: "/HowItWorksPage"
}, {
  name: "The Planner",
  url: "/ThePlannerPage"
}, {
  name: "Caddie",
  url: "/CaddiePage"
}, {
  name: "Connect",
  url: "/ConnectPage"
}];
export default function TheNetwork() {
  return <section data-section-id="116870" id="educational-roadmap" className="dark bg-[#0A0E14] text-[#F4EFE6]">
      {}
      <div className="h-[280px] bg-[#141A22] flex flex-col items-center justify-center border-b border-[#B8922A]/15 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-5 mix-blend-overlay pointer-events-none"></div>
        <h1 className="font-sans text-4xl md:text-5xl text-[#B8922A] tracking-[0.2em] uppercase relative z-10">
          Educational Roadmap
        </h1>
        <p className="font-serif italic text-[#F4EFE6]/70 mt-4 text-lg max-w-md text-center px-4 relative z-10">
          "The path to systematic mastery is paved with discipline and data." — The Caddie
        </p>
      </div>

      {}
      <div className="bg-[#0A0E14] py-20 px-6 border-b border-[#B8922A]/15">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {socialLinks.map((social, i) => <Card key={i} data-index={i} className={`bg-[#141A22] border-[#B8922A]/15 rounded-none hover:border-[#B8922A] transition-all duration-500 group ${i >= 4 ? 'opacity-40' : 'opacity-100'}`}>
                <CardContent className="p-8 flex flex-col items-center text-center gap-5 h-full justify-between">
                  <div className="flex flex-col items-center gap-5">
                    <div className="w-[44px] h-[44px] border border-[#B8922A] flex items-center justify-center text-[#B8922A] group-hover:bg-[#B8922A] group-hover:text-[#0A0E14] transition-colors duration-500 rounded-none">
                      <social.icon className="w-5 h-5" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h3 className="font-sans text-lg tracking-wider mb-2 text-[#F4EFE6] uppercase">
                        {social.name}
                      </h3>
                      <p className="font-serif text-[#F4EFE6]/60 text-base leading-relaxed">
                        {social.description}
                      </p>
                    </div>
                  </div>
                  <Link to={social.url} className="mt-4 font-sans text-[11px] text-[#B8922A] uppercase tracking-[0.3em] hover:text-[#D4AE52] transition-colors flex items-center gap-2">
                    {i >= 4 ? "Locked Access" : "View Episode"} <ArrowRight className="w-3 h-3" />
                  </Link>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>

      {}
      <div className="py-24 px-6 max-w-3xl mx-auto">
        <h2 className="font-sans text-[11px] uppercase tracking-[0.4em] text-[#B8922A] mb-8 text-center">
          Platform Navigation
        </h2>
        <div className="flex flex-col border-t border-[#B8922A]/30">
          {quickLinks.map((link, i) => <Link key={i} data-index={i} to={link.url} className="group flex items-center justify-between w-full py-5 border-b border-[#B8922A]/30 font-sans text-[11px] uppercase tracking-[0.3em] hover:bg-[#B8922A]/5 transition-colors px-4">
              <span className="text-[#F4EFE6] group-hover:text-[#D4AE52] transition-colors">
                {link.name}
              </span>
              <ArrowRight className="w-4 h-4 text-[#B8922A] transform group-hover:translate-x-2 transition-transform" />
            </Link>)}
        </div>
      </div>
    </section>;
}